import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserGeneratePassword = {
  userGeneratePassword: { data: null, loading: false, error: null },
};

export const userGeneratePassword = createAsyncThunk('user/userGeneratePassword', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/user/generate-password`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserGeneratePassword = {
  [userGeneratePassword.pending]: (state) => {
    state.userGeneratePassword.loading = true;
  },
  [userGeneratePassword.fulfilled]: (state, action) => {
    state.userGeneratePassword.loading = false;
    state.userGeneratePassword.data = action.payload;
    state.userGeneratePassword.error = null;
  },
  [userGeneratePassword.rejected]: (state, action) => {
    state.userGeneratePassword.loading = false;
    state.userGeneratePassword.error = action.payload;
  },
};
